
import { listadoTraslados } from '../../../components/Traslados/RegistrarTraslados';
import {
    FILTRO_TRASPASOS_ENVIADOS_REQUEST,
    FILTRO_TRASPASOS_ENVIADOS_SUCCESS,
    FILTRO_TRASPASOS_ENVIADOS_FAIL
} from '../../actions/Traspasos/types'

// Define el tipo para el estado inicial
interface PropsState {
    filtroListadoTraspasosEnviados: listadoTraslados[];
}
// Estado inicial tipado
const initialState: PropsState = {
    filtroListadoTraspasosEnviados: []
};

// Reducer con tipos definidos
const filtroListadoTraspasosEnviadosReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case FILTRO_TRASPASOS_ENVIADOS_REQUEST:
            return { ...state, loading: true };
        case FILTRO_TRASPASOS_ENVIADOS_SUCCESS:
            return {
                ...state,
                loading: false,
                filtroListadoTraspasosEnviados: action.payload,
            };
        case FILTRO_TRASPASOS_ENVIADOS_FAIL:
            return {
                ...state, loading: false,
                error: action.error,
                listadoTraspasos: []
            };
        default:
            return state;
    }
};



export default filtroListadoTraspasosEnviadosReducers;
